import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { projects } from '../data/projects';
import { ProjectSearch } from './ProjectSearch';

/* The only collapsed thing on the page, and only because it is a tool rather
   than content: 366 indexed rows would otherwise bury the libraries. */
export function ProjectSearchPanel() {
  return <details className="group rounded-[18px] border border-navy/10 bg-white" data-id="element-228" data-mp="2706sp4u0tymx">
      <summary className="flex cursor-pointer list-none items-center justify-between gap-4 p-6 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-navy focus-visible:ring-offset-2 focus-visible:ring-offset-paper sm:p-7" data-id="element-229" data-mp="2bx6ydemykzdi">
        <span data-id="element-230" data-mp="2lu1zm5am9dvh">
          <span className="block font-display text-[20px] font-semibold leading-tight text-navy sm:text-[22px]" data-id="element-231" data-mp="2pxrg07h50p5f">
            Find the right project
          </span>
          <span className="mt-1.5 block max-w-[40rem] font-sans text-[14.5px] leading-relaxed text-navy/60" data-id="element-232" data-mp="rjy9dc40q011">
            Search all {projects.length} projects in the twelve-book bonus library by material, age,
            build time, difficulty or mess.
          </span>
        </span>
        <ChevronDownIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-navy/40 transition-transform duration-200 ease-out group-open:rotate-180" strokeWidth={2} data-id="element-233" data-mp="2edvroecbthi3" />
      </summary>

      <div className="border-t border-navy/10 px-6 pb-7 pt-7 sm:px-7" data-id="element-234" data-mp="24ed7bwsi7tpi">
        <ProjectSearch data-id="element-235" data-mp="322x40coa5csn" />
      </div>
    </details>;
}